import { dataClient } from '../data/dataClient.js';

const MAX_RECENT_MESSAGES = 12;
const MAX_MESSAGE_CHARS = 12000;

function matchesQuery(record, query) {
  const haystack = JSON.stringify(record).toLowerCase();
  return String(query)
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .some((term) => haystack.includes(term));
}

export async function assembleContext(botId, sessionId, currentMessage) {
  const state = dataClient.peek();
  const bot = state.bots.find((item) => item.id === botId);

  if (!bot) throw new Error(`Bot ${botId} was not found.`);

  const session = state.chatSessions?.find((item) => item.id === sessionId);
  const module = session?.module || bot.module || 'headquarters';
  const messages = Object.values(state.messages || {})
    .flat()
    .filter((item) => item.module === module)
    .slice(-MAX_RECENT_MESSAGES);

  const memory = (state.businessMemory || []).filter(
    (item) => !item.module || item.module === module || matchesQuery(item, currentMessage)
  );

  const plans = (state.plans || []).filter(
    (item) => !item.module || item.module === module
  );

  const files = (state.files || []).filter(
    (item) => (Array.isArray(item.visibility) && item.visibility.includes(botId)) ||
      (Array.isArray(item.tags) && (item.tags.includes(module) || item.tags.includes('chat-attachment')))
  );

  const knowledgeSources = (state.knowledgeSources || []).filter(
    (item) => item.bot === botId || item.botId === botId
  );

  return {
    systemPrompt: bot.systemPrompt,
    brandProfile: state.brandProfile,
    files,
    knowledgeSources,
    latestChatSummary: (state.chatSummaries || [])
      .filter((item) => !item.sessionId || item.sessionId === sessionId)
      .slice(-1)[0] || null,
    recentMessages: messages
      .map((item) => `${item.sender}: ${item.text}`)
      .join('\n')
      .slice(-MAX_MESSAGE_CHARS),
    businessMemory: memory,
    plans,
    currentInput: currentMessage,
    bot: {
      id: bot.id,
      name: bot.name,
      role: bot.role,
      agentClass: bot.agentClass,
      tools: bot.tools || []
    }
  };
}